import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EQuestionType } from 'src/app/models/questionType.model';
import { Question } from 'src/app/models/question.model';
import { SmartTooltipComponent } from '../question/components/smart-tooltip/smart-tooltip.component';
import { QuestionFormDisplayComponent } from '../question-form-display/question-form-display.component';
import { DisplayByTypeDirective } from '../question/display-by-type.directive';
import { DisplayTitleQuestionComponent } from './components/display-title-question/display-title-question.component';
import { DisplayBigTitleQuestionComponent } from './components/display-big-title-question/display-big-title-question.component';
import { AnswersStore, StatusValidation } from 'src/app/store/answers-store';
import { combineLatest, debounceTime, map } from 'rxjs';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { DisplayApiFieldNameComponent } from "../question/components/display-api-field-name/display-api-field-name.component";
import { DisplayFilterFieldComponent } from "../question/components/display-api-field-name/display-filter-field/display-filter-field.component";

@Component({
    selector: 'que-question-display',
    imports: [CommonModule, SmartTooltipComponent, QuestionFormDisplayComponent, DisplayByTypeDirective, DisplayTitleQuestionComponent, DisplayBigTitleQuestionComponent,
        TranslateDirective, TranslatePipe, SvgIconComponent, DisplayApiFieldNameComponent, DisplayFilterFieldComponent],
    templateUrl: './question-display.component.html',
    styleUrls: ['./question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionDisplayComponent {
  @Input() question!: Question;
  eQuestionType = EQuestionType;
  @Input() isPreview = false;
  @Input() viewAnswer = false;

  #questionnaireStore = inject(QuestionnaireStore);
  #answerStore = inject(AnswersStore);

  stepsLength$ = this.#questionnaireStore.stepsLength$;
  isCurrentStepQuestions$ = this.#questionnaireStore.isCurrentStepQuestions$;
  isUser$ = toSignal(this.#questionnaireStore.isUser$);
  invalidCurrentQuestion$ = combineLatest([this.#answerStore.validCurrentAllStep$, this.#questionnaireStore.currentStepIndex$]).pipe(
    map(
      ([validAllSteps, index]) => {
        let currentStepValidation = validAllSteps.find(v => v.index == index);
        if (currentStepValidation?.statusStepValidation != StatusValidation.Error) {
          return false;
        }
        return currentStepValidation?.arr.find(q => q.questionId == this.question.id)?.statusAnswerValidation == StatusValidation.Error;
      }));

  isVisitedStep$ = toSignal(combineLatest([this.#answerStore.visitedSteps$, this.#questionnaireStore.currentStepIndex$]).pipe(map(([x, index]) => x.includes(index))))
  isShowError$ = toSignal(this.#answerStore.showIndication$);
}
